import { Component } from 'preact'
import TopicHelpfulness from '../topic-helpfulness/topicHelpfulness'

export class ContentHelpfulnessPreview extends Component {
  constructor () {
    super()
    this.setDataCallback = this.setDataCallback.bind(this)
    this.hideWidget = this.hideWidget.bind(this)
    this.state = {
      isVoted: false,
      isDismissed: false,
      animationClass: ''
    }
  }

  hideWidget () {
    this.setState({ animationClass: 'easy-out' }, () => {
      window.setTimeout(() => {
        this.setState({ isDismissed: true, animationClass: '' })
      }, 300)
    })
  }

  setDataCallback () {
    this.setState({ isVoted: true }, () => {
      window.setTimeout(() => {
        this.setState({ isVoted: false })
      }, 3000)
    })
  }

  render (props, state) {
    return (
      <div className='content-helpfulness_preview-container'>
        <div className='content-helpfulness_preview-widget-container'>
          <div className='content-helpfulness_preview-title'>Topic preview</div>
          <div className='content-helpfulness_preview-description'>This section is attached at the bottom of the first post</div>
          <TopicHelpfulness
            showIndicator={props.showIndicator}
            setData={this.setDataCallback}
            isVoted={state.isVoted}
            indicatorPercentage={80}
            phrases={props.phrases}
          />
        </div>
        <div className='content-helpfulness_preview-floating-container'>
          <div className='content-helpfulness_preview-title'>Bottom bar preview</div>
          <div className='content-helpfulness_preview-description'>This bottom bar will slide in when user scrolls past the first post</div>
          <TopicHelpfulness
            isSticky
            setData={this.setDataCallback}
            hideWidget={this.hideWidget}
            animationClass={state.animationClass}
            isDismissed={state.isDismissed}
            showIndicator={props.showIndicator}
            indicatorPercentage={80}
            isVoted={state.isVoted}
            phrases={props.phrases}
          />
        </div>
      </div>
    )
  }
}

export default ContentHelpfulnessPreview
